import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";

const lesson: Lesson = {
  id: "dca70e6c-8d63-48af-889a-e8a28b6034be",
  publicId: "6",
  name: "Transmission and reflection",
  difficulty: 1,
  contentTypes: { audio: false, interactive: true, video: false },

  body: [principle01, task01],
};

export default lesson;
